import {connect} from "../../../redux/utils"
import {bindActionCreators} from 'redux'
import {LowBalanceSettingsContainer} from "../LowBalanceSettingsContainer"
import {getSdbBalanceSettingsState} from "./selectors"
import {isTTAEnabled, isAnyUGREnabled, isAnyTZGEnabled, isWSDEnabled} from "../../../features/selectors"
import { getAnyTimeZoneGroupsList, getAnyUserGroupsListWithDefault, getUsersList} from "../../darSettings/selectors"
import sdbActions from './actions'

export default connect((state) => ({
    ...getSdbBalanceSettingsState(state),
    ugrEnabled: isAnyUGREnabled(state),
    tzgEnabled: isAnyTZGEnabled(state),
    ttaEnabled: isTTAEnabled(state),
    wsdEnabled: isWSDEnabled(state),
    userGroups: getAnyUserGroupsListWithDefault(state),
    timeZoneGroups: getAnyTimeZoneGroupsList(state),
    users: getUsersList(state),
}), (dispatch) => ({
    ...bindActionCreators(sdbActions, dispatch),
}))(LowBalanceSettingsContainer)



// WEBPACK FOOTER //
// ./web/js/administration/lowBalanceSettings/sdb/SdbLowBalanceSettingsContainer.js